import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as echarts from 'echarts';
let default_1 = class default_1 extends Vue {
    dataSeries;
    option;
    type;
    charts;
    // @Watch('dataSeries')
    // onDataSeriesChange(dataSeries: []) {
    //   this.initDataSeries(dataSeries);
    //   this.draw();
    // }
    onOptionChange(val) {
        this.draw();
    }
    initDataSeries(dataSeries) {
        this.option.series = dataSeries;
    }
    mounted() {
        this.initDataSeries(this.dataSeries);
        this.charts = echarts.init(this.$refs['barh']);
        this.draw();
    }
    draw() {
        if (!this.charts)
            return;
        this.charts.clear();
        this.charts.resize();
        //
        if (this.option?.tooltip) {
            this.option.tooltip.className =
                this.option.tooltip?.className ?? 'echarts-tooltip echarts-tooltip-dark';
        }
        this.charts.setOption(this.option, true);
    }
    onLocaleChange(newVal) {
        this.draw();
    }
    onResize() {
        this.charts && this.charts.resize();
    }
};
__decorate([
    Prop({})
], default_1.prototype, "dataSeries", void 0);
__decorate([
    Prop()
], default_1.prototype, "option", void 0);
__decorate([
    Prop()
], default_1.prototype, "type", void 0);
__decorate([
    Watch('option')
], default_1.prototype, "onOptionChange", null);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "onLocaleChange", null);
default_1 = __decorate([
    Component({ name: 'echartsContainer' })
], default_1);
export default default_1;
